import { render, staticRenderFns } from "./WAccountMenu.vue?vue&type=template&id=1b0ba0a2&"
import script from "./WAccountMenu.vue?vue&type=script&lang=ts&"
export * from "./WAccountMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports